import SwaggerView from './SwaggerView';

export default SwaggerView;
